/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Mcp_2_TitleInputs */

const en_vc_mcp_2_title = /** @type {(inputs: Vc_Mcp_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automate the boring parts`)
};

const zh_vc_mcp_2_title = /** @type {(inputs: Vc_Mcp_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把重复劳动交给 AI`)
};

/**
* | output |
* | --- |
* | "Automate the boring parts" |
*
* @param {Vc_Mcp_2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_mcp_2_title = /** @type {((inputs?: Vc_Mcp_2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Mcp_2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_mcp_2_title(inputs)
	return zh_vc_mcp_2_title(inputs)
});
export { vc_mcp_2_title as "vc.mcp.2.title" }